// extracted by mini-css-extract-plugin
export var createdDate = "_f1-1";
export var divider = "_f1-2";
export var headerDivider = "_f1-3";
export var messagesCard = "_f1-0";
export var messagesContainer = "_f1-6";
export var messagesContainerWrapper = "_f1-4";
export var showLeftPanelButton = "_f1-8";
export var topButtons = "_f1-7";
export var withPadding = "_f1-5";